import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconShaderEffect"><Path d="M20.8076 3.25195C20.9262 3.3846 21 3.5581 21 3.75V20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.5581 21 3.3846 20.9262 3.25195 20.8076L20.8076 3.25195Z" fill="currentColor"/><Path d="M3 18.9395V13.0605L13.0605 3H18.9395L3 18.9395Z" fill="currentColor"/><Path d="M3 10.9395V3.75C3 3.33579 3.33579 3 3.75 3H10.9395L3 10.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShaderEffect;
